import { IDataKeys } from 'k8s/datakeys.model'
import Action, { ArrayElement } from 'core/actions/Action'
import { cacheActions } from 'core/caching/cacheReducers'
import store from 'app/store'

const { dispatch } = store

class UpdateAction<
  D extends keyof IDataKeys,
  P extends Record<string, unknown> = Record<string, unknown>,
  R = ArrayElement<IDataKeys[D]>
> extends Action<D, P, R | void> {
  public get name() {
    return 'update'
  }

  protected async preProcess(params: P): Promise<void> {
    const { cacheKey, addCacheKey } = this.config
    dispatch(cacheActions.setUpdating({ cacheKey, updating: true }))
    if (addCacheKey) {
      dispatch(cacheActions.setUpdating({ cacheKey: addCacheKey, updating: true }))
    }
  }

  protected postProcess = (result, params: P): void => {
    if (!result) {
      return
    }
    const { cacheKey, addCacheKey, uniqueIdentifier } = this.config

    dispatch(
      cacheActions.updateItem({
        uniqueIdentifier,
        cacheKey,
        params,
        item: result,
      }),
    )
    dispatch(cacheActions.setUpdating({ cacheKey, updating: false }))
    if (addCacheKey) {
      dispatch(
        cacheActions.updateItem({
          uniqueIdentifier,
          cacheKey: addCacheKey,
          params,
          item: result,
        }),
      )
      dispatch(cacheActions.setUpdating({ cacheKey: addCacheKey, updating: false }))
    }
  }

  protected handleError(err, params: P, options) {
    const { cacheKey, addCacheKey } = this.config
    // Without this, if an error occurs loading can be stuck as true
    dispatch(cacheActions.setUpdating({ cacheKey, updating: false }))
    if (addCacheKey) {
      dispatch(cacheActions.setUpdating({ cacheKey: addCacheKey, updating: false }))
    }
    return super.handleError(err, params, options)
  }
}

export default UpdateAction
